module.exports = __webpack_public_path__ + "static/media/smallBerryLeft.4c40ad3e.svg";